module.exports = __webpack_public_path__ + "static/media/instructivoac2.9f8d482b.png";